// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles___wrapper___N77ID","label":"styles___label___3Cubl","checkmark":"styles___checkmark___231GV","checked":"styles___checked___2_Fml"};